// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadImg_btnCloseCustom__P4oz4 {
    width: 0.6em;
    height: 0.6em;
    color: black;
    opacity: 1;
  }
  
.UploadImg_btnCloseCustom__P4oz4:hover {
    color: red;
}
  `, "",{"version":3,"sources":["webpack://./src/components/style/UploadImg.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,UAAU;EACZ;;AAEF;IACI,UAAU;AACd","sourcesContent":[".btnCloseCustom {\n    width: 0.6em;\n    height: 0.6em;\n    color: black;\n    opacity: 1;\n  }\n  \n.btnCloseCustom:hover {\n    color: red;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnCloseCustom": `UploadImg_btnCloseCustom__P4oz4`
};
export default ___CSS_LOADER_EXPORT___;
